import { html, View } from 'rune-ts';
import type { Typo } from '../Typo/Typo';
import klass from './ButtonSnsIcon.module.scss';
import { Icon, type IconData } from '../Icon/Icon';
import { type SharedData } from '../../../util';

export interface ButtonSnsIconData {
  type: 'KAKAO' | 'NAVER' | 'GOOGLE' | 'APPLE' | 'FACEBOOK';
  label?: Typo;
}

export interface ButtonSnsIconOption {
  button_type?: 'mini' | 'label' | 'fullsize' | 'fullsize_center';
  active?: boolean;
  hasUnlinkIcon?: boolean;
  hasRightSpace?: boolean;
  sharedData?: SharedData;
}

export class ButtonSnsIcon extends View<ButtonSnsIconData> {
  constructor(
    data: ButtonSnsIconData,
    public option: ButtonSnsIconOption = {},
  ) {
    super(data);
  }
  override template() {
    const type = this.data.type.toLowerCase();
    const { active, hasUnlinkIcon, button_type } = this.option;

    const active_klass = active ? type : `${type}_inactive`;
    const icon_name = active_klass as IconData['name'];

    return html`<button
      type="button"
      class="${klass[active_klass]} ${klass.button_sns_icon}"
      data-button-type="${button_type ?? 'mini'}"
      data-type="${this.data.type}"
      data-active="${active}"
    >
      ${new Icon({ name: icon_name, size: 28 })}
      ${this.data.label ? html`<span class="${klass.label}">${this.data.label}</span>` : ''}
      ${hasUnlinkIcon && active
        ? html`<span class="${klass.unlink_icon}">${new Icon({ name: 'round_unlink' })} </span>`
        : ''}
      ${this.option.hasRightSpace ? html`<span class="${klass['w-28']}"></span>` : ''}
    </button> `;
  }
}
